import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NumericTextBox, Input } from '@progress/kendo-react-inputs';
import DatePickerContainer from '../components/DatePickerContainer';
import { deepClone, isEmpty, escapeSlashes } from '../helpers';
import Toolbar from "../components/Toolbar";
import ToolbarOption from '../components/ToolbarOption';
import isPage from '../hoc/isPage';
import moment from 'moment';


class InventorySetRulePage extends Component {


    static propTypes = {
        handleCloseModal: PropTypes.func,
        ruleID: PropTypes.number,
        orgID: PropTypes.number,
        reportGroupID: PropTypes.string
    }

    state = {
        rule: {}

    }

    componentDidMount() {


        // do a lookup of the data for the ruleID that was passed in, if any

        if (this.props.ruleID) {

            this.props.getData(`/api/portal/inventory/shapingRule/${this.props.ruleID}/GetRule`).then(response => {

                // convert effectiveDate and expiryDate into JS Date objects
                let effectiveDate = response.data.effectiveDate;
                let expiryDate = response.data.expiryDate;

                if (effectiveDate) {
                    effectiveDate = moment(effectiveDate, "YYYYMMDD").toDate();
                    //effectiveDate = dayjs("YYYYMMDD",effectiveDate);
                }
                if (expiryDate) {
                    expiryDate = moment(expiryDate, "YYYYMMDD").toDate();
                }

                const rule = {
                    ...response.data,
                    effectiveDate,
                    expiryDate
                };


                this.setState({ rule: rule });
            }).catch(error => {
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0176"));
                //console.log(error);
                return;
            });


        } else {

            this.setState({
                rule: {
                    orgId: this.props.orgID,
                    reportGroupID: this.props.reportGroupID
                }
            });
        }



    }



    handleSubmit = (event) => {
        event.preventDefault();

        let errorMessage = "";
        // validate form inputs


        // perform the following checks:
        // check whether min or max threshold type radio has been inputted
        // check whether threshold value has been set
        // check part number has been provided
        // if it's an existing rule, check expiry date and effective date - neither can be earlier than current date

        if (isEmpty(this.state.rule.thresholdType)) {
            errorMessage = this.props.returnLocalizedString("m0177");
        }
        else if (isEmpty(this.state.rule.thresholdValue)) {
            errorMessage = this.props.returnLocalizedString("m0178");
        }

        else if (isEmpty(this.state.rule.partNumber)) {
            errorMessage = this.props.returnLocalizedString("m0179");
        }
        else if (this.props.ruleID && (moment(this.state.rule.expiryDate, "YYYYMMDD") < moment(new Date()).format("YYYYMMDD"))) {
            errorMessage = this.props.returnLocalizedString("m0180");
        }
        else if (this.props.ruleID && (moment(this.state.rule.effectiveDate, "YYYYMMDD") < moment(new Date()).format("YYYYMMDD"))) {
            errorMessage = this.props.returnLocalizedString("m0181");
        }

        // if any errors at this point, then kill the create/update operation
        if (!isEmpty(errorMessage)) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), errorMessage);
            return;
        }


        const partNumber = escapeSlashes(this.state.rule.partNumber);

        this.props.getData(`/api/portal/part/${partNumber}/CheckPartExists`)
            .then(response => {


                if (response.data.partNumberExists) {
                    // prep the rule object for submission

                    let rule = deepClone(this.state.rule);



                    // call the sproc to create/update the rule


                    const expiryDate = (rule.expiryDate) ? moment(rule.expiryDate).format("YYYYMMDD") : null;
                    const effectiveDate = (rule.effectiveDate) ? moment(rule.effectiveDate).format("YYYYMMDD") : null;



                    this.props.postData("/api/portal/inventory/shapingRule/SetRule", { ...rule, expiryDate, effectiveDate }).then(response => {
                        this.props.alert("success", this.props.returnLocalizedString("m0036"), this.props.returnLocalizedString("m0182", ((this.props.ruleID) ? "m0032" : "m0033")));

                        // refresh the listing of rules
                        this.props.handleRefreshListing();

                        // if creating a new rule, then close the modal
                        if (!this.props.ruleID) {
                            this.props.handleCloseModal();
                        }

                    }).catch(error => {
                        this.props.alert("error", this.props.returnLocalizedString("m0023"), error.response.data);
                    });


                } else {
                    this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0183"));
                    return;
                }
            }).catch(error => {
                //console.log(error);
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0184"));
                return;
            });





    }

    handleChange = (e) => {



        const rule = {
            ...this.state.rule,
            [e.target.name]: e.target.value
        }

        this.setState({ rule: rule });

    }
    handleClearDate = (fieldName) => {
        const updatedRule = { ...this.state.rule };
        updatedRule[fieldName] = null;

        this.setState({ rule: updatedRule });
    }

    render() {

        if (!this.state.rule) {
            return (<React.Fragment />);
        }

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0032@ updated !DEVNOTE! Action status
        //!DBTRANS! @m0033@ created !DEVNOTE! Action status
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
        //!DBTRANS! @m0176@ The data for this rule could not be retrieved. !DEVNOTE!\ Action status
        //!DBTRANS! @m0177@ You must choose between either a minimum or maximum threshold. !DEVNOTE! Action status reason
        //!DBTRANS! @m0178@ You must enter an inventory threshold value. !DEVNOTE! Action status reason
        //!DBTRANS! @m0179@ You must enter a part number. !DEVNOTE! Action status reason
        //!DBTRANS! @m0180@ You can't set expiry date to be before today. !DEVNOTE! Action status reason
        //!DBTRANS! @m0181@ You can't set effective date to be before today. !DEVNOTE! Action status reason
        //!DBTRANS! @m0182@ This inventory shaping rule was successfully %action%! !DEVNOTE! Action status reason
        //!DBTRANS! @m0183@ The part number does not exist !DEVNOTE! Action status reason
        //!DBTRANS! @m0184@ We could not verify whether the part number exists. !DEVNOTE! Action status reason
        //!DBTRANS! @m0185@ Create Inventory Rule !DEVNOTE! Button label
        //!DBTRANS! @m0186@ Modify Inventory Rule !DEVNOTE! Button label
        //!DBTRANS! @m0187@ For which part number(s)? !DEVNOTE! Input field label
        //!DBTRANS! @m0188@ Are you setting a minimum or maximum inventory threshold? !DEVNOTE! Input field label
        //!DBTRANS! @m0189@ Minimum !DEVNOTE! Input field label
        //!DBTRANS! @m0190@ Maximum !DEVNOTE! Input field label
        //!DBTRANS! @m0191@ Part Number !DEVNOTE! Input field label
        //!DBTRANS! @m0192@ Inventory Threshold !DEVNOTE! Input field label
        //!DBTRANS! @m0193@ Set rule effective date: !DEVNOTE! Input field label
        //!DBTRANS! @m0194@ Set rule expiry date: !DEVNOTE! Input field label
        //!DBTRANS! @m0195@ ROI % !DEVNOTE! Input field label
        //!DBTRANS! @m0196@ %space%greater than or equal to !DEVNOTE! Input field label
        //!DBTRANS! @m0197@ Special Order % !DEVNOTE! Input field label
        //!DBTRANS! @m0198@ %space%less than or equal to !DEVNOTE! Input field label

        return (
            <div className="position-relative">
                <div className="k-window-title k-dialog-title ">
                    {isEmpty(this.props.ruleID) ? this.props.returnLocalizedString("m0185") : this.props.returnLocalizedString("m0186")}
                </div>
                <Toolbar>
                    <ToolbarOption type="save" handleClick={this.handleSubmit} />
                    <ToolbarOption type="close" handleClick={this.props.handleCloseModal} />

                </Toolbar>
                <form className="top-margin-20" ref={form => this.form = form}>
                    <div className="grid grid-gap0">
                        <div className="grid-row">
                            <div className="grid-col m-col-12 t-col-6 ">

                                <div className="k-form-field">
                                    <div className="">{this.props.returnLocalizedString("m0187")}</div>

                                    <Input required={true} name="partNumber" readOnly={!isEmpty(this.props.ruleID)} label= {this.props.returnLocalizedString("m0191")} onChange={this.handleChange} value={this.state.rule.partNumber} />
                                </div>
                                <div className="k-form-field">
                                    <div className="bottom-margin-5">{this.props.returnLocalizedString("m0188")}</div>

                                    <div>
                                        <input required="required" checked={this.state.rule.thresholdType === "min"} onChange={this.handleChange} type="radio" name="thresholdType" id="min" value="min" className="k-radio" />

                                        <label className="k-radio-label" htmlFor="min">{this.props.returnLocalizedString("m0189")}</label>

                                        <input checked={this.state.rule.thresholdType === "max"} onChange={this.handleChange} type="radio" name="thresholdType" id="max" value="max" className="k-radio" />
                                        <label className="k-radio-label" htmlFor="max">{this.props.returnLocalizedString("m0190")}</label>
                                    </div>
                                    <NumericTextBox value={this.state.rule.thresholdValue} required={true} onChange={this.handleChange} name="thresholdValue" label= {this.props.returnLocalizedString("m0192")} />
                                </div>



                            </div>

                            <div className="grid-col m-col-12 t-col-6">

                                <div className="k-form-field">
                                    <div>{this.props.returnLocalizedString("m0193")}</div>
                                    <DatePickerContainer handleClearDate={this.handleClearDate} name="effectiveDate" onChange={this.handleChange} value={this.state.rule.effectiveDate} />

                                </div>

                                <div className="k-form-field">
                                    <div>{this.props.returnLocalizedString("m0194")}</div>
                                    <DatePickerContainer handleClearDate={this.handleClearDate} name="expiryDate" onChange={this.handleChange} value={this.state.rule.expiryDate} />

                                </div>


                                <div className="k-form-field">
                                    <div><strong className="uppercase">{this.props.returnLocalizedString("m0195")}</strong>{this.props.returnLocalizedString("m0196")}</div>
                                    <NumericTextBox name="roiTarget" label="Enter value" onChange={this.handleChange} value={this.state.rule.roiTarget} />
                                </div>

                                <div className="k-form-field">
                                    <div><strong className="uppercase">{this.props.returnLocalizedString("m0197")}</strong>{this.props.returnLocalizedString("m0198")}</div>
                                    <NumericTextBox name="specialOrderTarget" label="Enter value" onChange={this.handleChange} value={this.state.rule.specialOrderTarget} />
                                </div>
                            </div>

                        </div>


                    </div>


                </form>
            </div>
        );
    }

}

export default isPage(InventorySetRulePage);


// WEBPACK FOOTER //
// ./src/containers/InventorySetRulePage.js